export default {

    SET_SCREEN: "SET_SCREEN",

    GET_BUNDLE_LIST_REQUEST: "GET_BUNDLE_LIST_REQUEST",
    GET_BUNDLE_LIST_RECEIVE: "GET_BUNDLE_LIST_RECEIVE",
    GET_BUNDLE_LIST_ERROR: "GET_BUNDLE_LIST_ERROR",

    GET_API_LIST_REQUEST: "GET_API_LIST_REQUEST",
    GET_API_LIST_RECEIVE: "GET_API_LIST_RECEIVE",
    GET_API_LIST_ERROR: "GET_API_LIST_ERROR",

    CREATE_BUNDLE_POST_REQUEST: "CREATE_BUNDLE_POST_REQUEST",
    CREATE_BUNDLE_POST_RECEIVE: "CREATE_BUNDLE_POST_RECEIVE",
    CREATE_BUNDLE_POST_ERROR: "CREATE_BUNDLE_POST_ERROR",

    UPDATE_BUNDLE_PUT_REQUEST: "UPDATE_BUNDLE_PUT_REQUEST",
    UPDATE_BUNDLE_PUT_RECEIVE: "UPDATE_BUNDLE_PUT_RECEIVE",
    UPDATE_BUNDLE_PUT_ERROR: "UPDATE_BUNDLE_PUT_ERROR",
    CLEAR_BUNDLE_UPDATE_ERRORS: "CLEAR_BUNDLE_UPDATE_ERRORS",

    GET_BUNDLE_PRICE_PLANS_REQUEST: "GET_BUNDLE_PRICE_PLANS_REQUEST",
    GET_BUNDLE_PRICE_PLANS_RECEIVE: "GET_BUNDLE_PRICE_PLANS_RECEIVE",
    GET_BUNDLE_PRICE_PLANS_ERROR: "GET_BUNDLE_PRICE_PLANS_ERROR",
    RESET_BUNDLE_PRICE_PLANS: "RESET_BUNDLE_PRICE_PLANS",
    RESET_SELECTED_PRICING_PLAN: "RESET_SELECTED_PRICING_PLAN",
    RESET_BUNDLE_PLAN_DETAILS: "RESET_BUNDLE_PLAN_DETAILS",
    RESET_BUNDLE_PLAN: "RESET_BUNDLE_PLAN",

    CREATE_BUNDLE_PRICE_PLAN_REQUEST: "CREATE_BUNDLE_PRICE_PLAN_REQUEST",
    CREATE_BUNDLE_PRICE_PLAN_RECEIVE: "CREATE_BUNDLE_PRICE_PLAN_RECEIVE",
    CREATE_BUNDLE_PRICE_PLAN_ERROR: "CREATE_BUNDLE_PRICE_PLAN_ERROR",

    UPDATE_BUNDLE_PRICE_PLAN_REQUEST: "UPDATE_BUNDLE_PRICE_PLAN_REQUEST",
    UPDATE_BUNDLE_PRICE_PLAN_RECEIVE: "UPDATE_BUNDLE_PRICE_PLAN_RECEIVE",
    UPDATE_BUNDLE_PRICE_PLAN_ERROR: "UPDATE_BUNDLE_PRICE_PLAN_ERROR",

    FETCH_PLAN_DETAILS_REQUEST: "FETCH_PLAN_DETAILS_REQUEST",
    FETCH_PLAN_DETAILS_RECEIVE: "FETCH_PLAN_DETAILS_RECEIVE",
    FETCH_PLAN_DETAILS_ERROR: "FETCH_PLAN_DETAILS_ERROR",
    CLEAR_FETCH_PLAN_DETAILS_ERROR: "CLEAR_FETCH_PLAN_DETAILS_ERROR",
    LOAD_SUB_PLANS_FROM_DETAILS: "LOAD_SUB_PLANS_FROM_DETAILS",

    CLEAR_ADD_EDIT_PRICE_PLAN_ERROR: "CLEAR_ADD_EDIT_PRICE_PLAN_ERROR",
    SET_SELECTED_PRICING_PLAN: "SET_SELECTED_PRICING_PLAN",
    SET_SELECTED_BUNDLE: "SET_SELECTED_BUNDLE",
    SET_PRICE_PLAN_FOR_HISTORY: "SET_PRICE_PLAN_FOR_HISTORY",
    CLEAR_PRICE_PLAN_HISTORY: "CLEAR_PRICE_PLAN_HISTORY",
    SET_CREATE_BUNDLE_ERROR: "SET_CREATE_BUNDLE_ERROR",
    SET_PREV_SCREEN_FOR_HISTORY: "SET_PREV_SCREEN_FOR_HISTORY",

    HANDLE_PLAN_NAME_CHANGE: "HANDLE_PLAN_NAME_CHANGE",
    HANDLE_PLAN_ID_CHANGE: "HANDLE_PLAN_ID_CHANGE",
    HANDLE_PLAN_VISIBILITY_CHANGE: "HANDLE_PLAN_VISIBILITY_CHANGE",
    HANDLE_INSTALL_ENABLE_CHANGE: "HANDLE_INSTALL_ENABLE_CHANGE",
    HANDLE_INSTALL_FEE_CHANGE: "HANDLE_INSTALL_FEE_CHANGE",
    HANDLE_INSTALL_FEE_CATALOG_CHANGE: "HANDLE_INSTALL_FEE_CATALOG_CHANGE",
    HANDLE_MONTH_FEE_CHANGE: "HANDLE_MONTH_FEE_CHANGE",
    HANDLE_PLAN_TYPE_CHANGE: "HANDLE_PLAN_TYPE_CHANGE",
    HANDLE_PLAN_CATALOG_CHANGE: "HANDLE_PLAN_CATALOG_CHANGE",
    HANDLE_PLAN_OVERAGE_CATALOG_CHANGE: "HANDLE_PLAN_OVERAGE_CATALOG_CHANGE",
    HANDLE_PLAN_TOGGLE_CHANGE: "HANDLE_PLAN_TOGGLE_CHANGE",

    UPDATE_BUNDLE_PATCH_REQUEST: "UPDATE_BUNDLE_PATCH_REQUEST",
    UPDATE_BUNDLE_PATCH_RECEIVE: "UPDATE_BUNDLE_PATCH_RECEIVE",
    UPDATE_BUNDLE_PATCH_ERROR: "UPDATE_BUNDLE_PATCH_ERROR",

    DELETE_BUNDLE_DELETE_REQUEST: "DELETE_BUNDLE_DELETE_REQUEST",
    DELETE_BUNDLE_DELETE_RECEIVE: "DELETE_BUNDLE_DELETE_RECEIVE",
    DELETE_BUNDLE_DELETE_ERROR: "DELETE_BUNDLE_DELETE_ERROR",

    // to fetch api endpoints and channels
    GET_BUNDLE_API_ENDPOINTS_REQUEST: "GET_BUNDLE_API_ENDPOINTS_REQUEST",
    GET_BUNDLE_API_ENDPOINTS_RECEIVE: "GET_BUNDLE_API_ENDPOINTS_RECEIVE",
    GET_BUNDLE_API_ENDPOINTS_ERROR: "GET_BUNDLE_API_ENDPOINTS_ERROR",
    
    // set sub plan
    SET_SUB_PLAN: "SET_SUB_PLAN",
    CLEAR_SUB_PLAN: "CLEAR_SUB_PLAN", // no method within reducer
    // to create sub plan container as per the provided details
    CREATE_SUB_PLAN_CONTAINER: "CREATE_SUB_PLAN_CONTAINER",
    // use it for editing existing sub plan
    SET_SUB_PLAN_CONTAINER: "SET_SUB_PLAN_CONTAINER",
    SET_SELECTED_SUB_PLAN_CONTAINER: "SET_SELECTED_SUB_PLAN_CONTAINER",
    CLEAR_SUB_PLAN_CONTAINER: "CLEAR_SUB_PLAN_CONTAINER", // not yet implemented
    REMOVE_SUB_PLAN_CONTAINER: "REMOVE_SUB_PLAN_CONTAINER",

    HANDLE_SUB_PLAN_TITLE_CHANGE: "HANDLE_SUB_PLAN_TITLE_CHANGE",
    HANDLE_SUB_PLAN_BASE_VALUE_CHANGE: "HANDLE_SUB_PLAN_BASE_VALUE_CHANGE",
    HANDLE_SUB_PLAN_DESCRIPTION_CHANGE: "HANDLE_SUB_PLAN_DESCRIPTION_CHANGE",
    HANDLE_SUB_PLAN_RADIO_CHANGE: "HANDLE_SUB_PLAN_RADIO_CHANGE",
    HANDLE_SUB_PLAN_CONTAINER_QUOTA_LIMIT_CHANGE: "HANDLE_SUB_PLAN_CONTAINER_QUOTA_LIMIT_CHANGE",
    HANDLE_SUB_PLAN_CONTAINER_OVERAGES_CHANGE: "HANDLE_SUB_PLAN_CONTAINER_OVERAGES_CHANGE",
    HANDLE_SUB_PLAN_RESET_CHANGE: "HANDLE_SUB_PLAN_RESET_CHANGE",

    REMOVE_TOAST1: "REMOVE_TOAST1",
    RESET_ALL: "RESET_ALL",
    SET_DRAFT_SUB_PLAN_STATE: "SET_DRAFT_SUB_PLAN_STATE",
    CLEAR_DRAFT_SUB_PLAN_STATE: "CLEAR_DRAFT_SUB_PLAN_STATE"
}